<template>
  <motion.div
    :initial="{ opacity: 0, y: 50 }"
    :while-in-view="{ opacity: 1, y: 0 }"
    :inViewOptions="{ once: true }"
    :transition="{ duration: 0.6, ease: 'easeOut' }"
  >
    <slot />
  </motion.div>
</template>

<script setup lang="ts">
import { motion } from 'motion-v';
</script>
